import withLink from 'hoc/withLink';
import { useBreakpointValueGS } from 'hooks/useBreakpointValueGS';
import { useMemo } from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { calcHeightWithWidth, calcSizeForDevice } from 'utils/index';
import { Platform } from 'utils/platform';

import TitleCard from './TitleCard';

import FastImage from 'components/FastImage';

const MidCard: React.FC<CardProps & { style?: StyleProp<ViewStyle> }> = ({
  uri,
  title,
  imgTitle,
  reference,
  style,
  ...rest
}) => {
  const midCardAspectRatio = 2;
  const overrideBaseWidth = rest.override?.cardWidth?.base;
  const overrideLgWidth = rest.override?.cardWidth?.lg || rest.override?.cardWidth?.base;
  const overrideXlWidth = rest.override?.cardWidth?.xl || rest.override?.cardWidth?.base;
  const overrideSmWidth = rest.override?.cardWidth?.sm || rest.override?.cardWidth?.base;
  const overrideXsWidth = rest.override?.cardWidth?.xs || rest.override?.cardWidth?.base;

  const midCardWidth = useBreakpointValueGS({
    xl: overrideXlWidth || calcSizeForDevice(159, 260),
    lg: overrideLgWidth || 159,
    sm: overrideSmWidth || (Platform.isAndroidTV ? 130 : 174),
    xs: overrideXsWidth || 135,
    base: overrideBaseWidth || 106,
  });

  const midCardHeight = useMemo(
    () => calcHeightWithWidth(midCardWidth ?? 106, midCardAspectRatio),
    [midCardWidth, midCardAspectRatio]
  );

  return (
    <View
      style={[
        styles.card,
        {
          width: midCardWidth,
          height: midCardHeight,
        },
        style,
      ]}
      {...rest}>
      {uri ? (
        <FastImage source={{ uri }} style={{ width: '100%', height: '100%', borderRadius: 8 }} />
      ) : (
        <TitleCard title={title || imgTitle} reference={reference} />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#070d31',
    borderWidth: 3,
    borderColor: '#2240FF',
    borderRadius: 8,
    overflow: 'hidden',
  },
});

export default withLink(MidCard, 'MidCard');
